import {
  Flex,
  IconButton,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { RiInformationLine } from "react-icons/ri";
import { TipTag } from "./TipTag";

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  image?: React.ReactNode;
};
export const FormHelpPopover: React.FC<Props> = ({
  children,
  image,
  title,
}) => {
  return (
    <Popover>
      <PopoverTrigger>
        <IconButton
          aria-label="Title help"
          size="xs"
          icon={<RiInformationLine />}
          variant="ghost"
          colorScheme="gray"
        ></IconButton>
      </PopoverTrigger>
      <PopoverContent shadow="xl">
        {image}
        <Flex direction="column" margin={6} gap="2" fontSize="md">
          <TipTag />
          <Text fontSize="lg" fontWeight="bold">
            {title}
          </Text>
          {children}
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
